<template>
  <div class="container">
    <!-- Modal -->
    <div v-if="this.$store.state.modal.extraContratual.show === true" class="in show modal fade adicionarExtra"
      role="dialog">
      <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
          <div :class="[(this.$store.state.modal.extraContratual.status) ? 'sucesso' : 'falhou', 'modal-header']">
            <button type="button" class="close" data-dismiss="modal" v-on:click="fecharModal()">&times;</button>
            <h4 class="modal-title alert-title">
              <span></span>Pagamento Extracontratual
            </h4>
          </div>

          <div class="modal-body content-body">
            <div>
              <fieldset>
                <ul>
                  <li>Estado: {{ dadosFechamento.uf_selecionada }}</li>
                  <li>Ano: {{ dadosFechamento.ano_selecionado }}</li>
                  <li>Mês referente: {{ dadosFechamento.mesSelecionado }}</li>
                  <li>Tipo contrato: {{ dadosFechamento.contrato_selecionado }}</li>
                  <li>Número Contrato: {{ contrato.numero_contrato_original }}</li>
                </ul>
              </fieldset>

              <fieldset>
                <legend>Valores Oi</legend>
                <div class="form-group">
                  <!-- <div class="row">
                    <div class="col-md-6">
                      <legend>Valor Oi</legend>
                      <money v-model="formFechamentoExtra.valor.valor" id="valor" name="valor" v-bind="money"></money>
                    </div>
                    <div class="col-md-6">
                      <legend>Anexar arquivo Oi</legend>
                    <input type="file" ref="arquivo_extra" @change="setArquivo($event)" >    
                    </div>
                  </div> -->
                  <legend>Valor Total</legend>
                  <money v-model="formFechamentoExtra.valor_extra.valor" id="valor_extra" name="valor_extra" v-bind="money"></money>
                  <hr>

                  <legend>Anexar Evidência</legend>
                  <input type="file" name="arquivo_extra" ref="arquivo_extra" @change="setArquivo($event)">
                  <hr>

                  <legend>{{ formFechamentoExtra.arquivo_carga_extra.placeholder }}</legend>
                  <input type="file" name="arquivo_carga_extra" :ref="formFechamentoExtra.arquivo_carga_extra.nome"
                    @change="setArquivoCarga($event)">
                  <small class="form-text text-muted">
                    Cadastre todas as siglas com seus respectivos valores em uma tabela Excel com duas colunas, conforme
                    este <a href="/static/modelo-extracontratual.xlsx" download>modelo</a>
                  </small>
                  <!-- <fieldset v-if="formFechamentoExtra.comodato.valor">                              
                    <div>
                      <legend>Siglas prédios</legend>
                      <multiselect v-model="selected" :options="siglas" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Selecione as siglas" label="sigla" track-by="sigla" :preselect-first="false" :required="true">
                        <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} siglas selecionadas</span></template>
                        <template slot="selection" slot-scope="{ values, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} siglas selecionadas</span></template>
                      </multiselect>
                    </div>
                  </fieldset> -->

                </div>
              </fieldset>

              <fieldset>
                <legend>Valores Comodato</legend>
                <div class="form-group">

                  <legend>Valor Total Comodato</legend>
                  <money v-model="formFechamentoExtra.valor_comodato.valor" id="valor_comodato" name="valor_comodato" v-bind="money">
                  </money>
                  <hr>

                  <legend>Anexar Evidência Comodato</legend>
                  <input type="file" name="arquivo_comodato" ref="arquivo_comodato" @change="setArquivoComodato($event)">
                  <hr>

                  <legend>{{ formFechamentoExtra.arquivo_carga_comodato.placeholder }}</legend>
                  <input type="file" name="arquivo_carga_comodato" :ref="formFechamentoExtra.arquivo_carga_comodato.nome"
                    @change="setArquivoCargaComodato($event)">
                  <small class="form-text text-muted">
                    Cadastre todas as siglas com seus respectivos valores em uma tabela Excel com duas colunas, conforme
                    este <a href="/static/modelo-comodato-extracontratual.xlsx" download>modelo</a>
                  </small>

                </div>
              </fieldset>

              <!-- <fieldset>
                <legend>Tipo de serviço:</legend>
                <div class="servico-selector">
                  <select name="tipo_servico" id="tipo_servico" v-model="servicoAtual">
                    <option :value="null">Selecione o tipo de serviço</option>
                    <option v-for="servico in servicosDisponiveis" :key="servico.id" :value="servico">{{ servico.descricao }}</option>
                  </select>
                  <button type="button" class="btn-adicionar-servico" @click="adicionarServico()" :disabled="!servicoAtual">
                    + Adicionar
                  </button>
                </div>
                <ul class="lista-servicos" v-if="servicosSelecionados.length > 0">
                  <li v-for="(servico, index) in servicosSelecionados" :key="servico.id">
                    <span>{{ servico.descricao }}</span>
                    <button type="button" class="btn-remover-servico" @click="removerServico(index)">✕</button>
                  </li>
                </ul>
              </fieldset> -->

              <fieldset>
                <legend>Descrição :</legend>
                <div class="input-group textarea">
                  <textarea id="descricao" v-model="formFechamentoExtra.descricao.valor"
                    :placeholder="formFechamentoExtra.descricao.placeholder"></textarea>
                </div>
              </fieldset>
            </div>
          </div>

          <div class="modal-footer">
            <button v-on:click="salvarAplicacaoExtra()" type="button" class="btn btn-primary pull-right"
              data-dismiss="modal" v-if="controlerBtnSubmit">Salvar
            </button>
            <button type="button" class="btn btn-primary btn-submit" disabled v-else><i class='fa fa-refresh fa-spin'></i>
              aguarde...</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Money } from 'v-money'
import Multiselect from 'vue-multiselect'
export default {
  data () {
    return {
      contrato: [],
      siglas: [],
      servicos: [],
      servicoAtual: null,
      servicosSelecionados: [],
      selected: [],
      dadosFechamento: '',
      verificaRegistroAnterior: '',
      env: process.env,
      controlerBtnSubmit: true,
      formFechamentoExtra: {
        usuario_nome: { nome: 'usuario_nome', valor: this.$store.state.login.loginUsuario.usuario.name, status: undefined, tipo: '' },
        usuario_email: { nome: 'usuario_email', valor: this.$store.state.login.loginUsuario.usuario.email, status: undefined, tipo: '' },
        valor_extra: { nome: 'valor_extra', placeholder: 'Apenas valores monetários R$', valor: '', tipo: 'valor' },
        valor_comodato: { nome: 'valor_comodato', placeholder: 'Apenas valores monetários R$', valor: '', tipo: 'valor' },
        descricao: { nome: 'descricao', placeholder: 'Digite uma descrição', valor: '', tipo: 'texto' },
        arquivo_extra: { nome: 'arquivo_extra', placeholder: 'Anexar arquivo', valor: '', tipo: 'arquivo', status: undefined },
        arquivo_carga_extra: { nome: 'arquivo_carga_extra', placeholder: 'Arquivo de carga dos Valores Oi', valor: '', tipo: 'arquivo', status: undefined },
        arquivo_comodato: { nome: 'arquivo_comodato', placeholder: 'Anexar arquivo', valor: '', tipo: 'arquivo', status: undefined },
        arquivo_carga_comodato: { nome: 'arquivo_carga_comodato', placeholder: 'Arquivo de carga dos Valores Comodato', valor: '', tipo: 'arquivo', status: undefined }
        // selected: {nome: 'selected', placeholder: '', valor: '', tipo: '', status: undefined}
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: ' ',
        precision: 2,
        masked: false
      }
    }
  },
  components: {
    Money,
    Multiselect
  },
  computed: {
    servicosDisponiveis () {
      const idsSelecionados = this.servicosSelecionados.map(s => s.id)
      return this.servicos.filter(s => !idsSelecionados.includes(s.id))
    }
  },
  mounted: function () {
    // let vm = this
    this.dadosFechamentoExtra()
    this.getContratoAtual()
    this.getSiglasPredios()
    this.getServicos()
    // setTimeout(function () {
    //   vm.verificaSeExisteRegistroAnterior()
    // }, 8000)
  },
  methods: {
    fecharModal: function () {
      localStorage.removeItem('fechamentoExtra.dadosFechamento')
      this.$store.commit('setExtraContratual', { conteudo: null, show: false })
    },
    dadosFechamentoExtra () {
      this.dadosFechamento = this.$store.state.fechamentoExtra.dadosFechamento
    },
    getContratoAtual () {
      let vm = this
      let formContratoAtual = {
        'tipo_imovel_servico_id': this.$store.state.fechamentoExtra.dadosFechamento.id_contrato,
        'uf_id': this.$store.state.fechamentoExtra.dadosFechamento.uf_id,
        'ano_selecionado': this.$store.state.fechamentoExtra.dadosFechamento.ano_selecionado
      }
      this.$axios.post(`${this.env.FINANCEIRO.SLA}/getcontratoatual`, formContratoAtual, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`,
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        vm.contrato = response.data
      })
    },
    getSiglasPredios () {
      let vm = this
      let formContratoAtual = {
        'tipo_imovel_servico_id': this.$store.state.fechamentoExtra.dadosFechamento.id_contrato,
        'uf_id': this.$store.state.fechamentoExtra.dadosFechamento.uf_id,
        'ano_selecionado': this.$store.state.fechamentoExtra.dadosFechamento.ano_selecionado
      }
      // let uf = this.$store.state.fechamentoExtra.dadosFechamento.uf_id
      this.$axios.post(`${this.env.FINANCEIRO.SLA}/getSiglasPredios`, formContratoAtual, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`,
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        vm.siglas = response.data
      })
    },
    getServicos () {
      let vm = this
      this.$axios.post(`${this.env.FINANCEIRO.SLA}/getServicos`, {
        'tipo_imovel_servico_id': this.$store.state.fechamentoExtra.dadosFechamento.id_contrato
      }, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`,
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        vm.servicos = response.data
      }).catch(error => {
        console.log('Erro ao carregar serviços:', error)
      })
    },
    adicionarServico () {
      if (this.servicoAtual) {
        this.servicosSelecionados.push(this.servicoAtual)
        this.servicoAtual = null
      }
    },
    removerServico (index) {
      this.servicosSelecionados.splice(index, 1)
    },
    setArquivo: function (event) {
      this.formFechamentoExtra.arquivo_extra.valor = event.target.files[0]
    },
    setArquivoCarga: function (event) {
      this.formFechamentoExtra.arquivo_carga_extra.valor = event.target.files[0]
    },
    setArquivoComodato: function (event) {
      this.formFechamentoExtra.arquivo_comodato.valor = event.target.files[0]
    },
    setArquivoCargaComodato: function (event) {
      this.formFechamentoExtra.arquivo_carga_comodato.valor = event.target.files[0]
    },
    salvarAplicacaoExtra () {
      let vm = this
      if (!this.validacaoForm()) {
        this.$store.commit('setAlert', { msg: 'Preencha corretamente os campos.', status: false, show: true })
        return
      }

      let form = this.preencherFormData()

      // if (this.verificaRegistroAnterior.id) {
      //   if (!confirm('Já existe um valor extracontratual registrado neste mês. Deseja substituí-lo?')) {
      //     vm.fecharModal()
      //     vm.limparDadosFormulario()
      //     return this.$router.push('/ExibirFechamentoExtra')
      //   }
      // }
      this.controlerBtnSubmit = false
      this.$axios.post(`${this.env.FINANCEIRO.SLA}/salvarFechamentoExtra`, form, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`,
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (response) {
        let refreshComponentes = Math.floor(Math.random() * 2 * 1000)
        document.getElementById('alertGlobal').style.zIndex = 9999
        if (response.data.erro) {
          vm.$store.commit('setAlert', { msg: response.data.erro, status: false, show: true })
          vm.controlerBtnSubmit = true
          return
        }
        if (response.status === 200 || response.status === 201) {
          vm.$store.commit('setAlert', { msg: `Informações salvas com sucesso.`, status: true, show: true })
        } else {
          vm.$store.commit('setAlert', { msg: `A Aplicação de extra não foi salva.`, status: false, show: true })
        }
        vm.fecharModal()
        vm.limparDadosFormulario()
        vm.controlerBtnSubmit = true
        vm.$store.commit('setRefreshComponente', refreshComponentes)
        vm.$router.push('/ExibirFechamentoExtra')
      }).catch(error => {
        vm.$store.commit('setAlert', { msg: `${error}`, status: false, show: true })
        vm.controlerBtnSubmit = true
      })
    },
    verificaSeExisteRegistroAnterior () {
      // let form = this.preencherFormDataVerifiarRegistroAnterior()
      // let vm = this
      // this.$axios.post(`${this.env.FINANCEIRO.SLA}/verificaSeExisteRegistroAnterior`, form, {
      //   headers: {
      //     'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`,
      //     'Content-Type': 'multipart/form-data'
      //   }
      // }).then(function (response) {
      //   vm.verificaRegistroAnterior = response.data
      // }).catch(error => {
      //   console.log(error)
      // })
    },
    preencherFormData () {
      let formData = new FormData()
      formData.append('valor_comodato', this.formFechamentoExtra.valor_comodato.valor)
      formData.append('valor_extra', this.formFechamentoExtra.valor_extra.valor)
      formData.append('descricao_extra', this.formFechamentoExtra.descricao.valor)

      let elemExtra = this.$refs[this.formFechamentoExtra.arquivo_extra.nome]

      if (elemExtra.value) {
        formData.append('arquivo_extra', elemExtra.files[0])
        this.formFechamentoExtra.arquivo_extra.valor = this.$refs.arquivo_extra.value.replace('C:\\fakepath\\', '')
      } else {
        formData.append('arquivo_extra', this.formFechamentoExtra.arquivo_extra.valor)
      }

      let elemCargaExtra = this.$refs[this.formFechamentoExtra.arquivo_carga_extra.nome]

      if (elemCargaExtra.value) {
        formData.append('arquivo_carga_extra', elemCargaExtra.files[0])
        this.formFechamentoExtra.arquivo_carga_extra.valor = this.$refs.arquivo_carga_extra.value.replace('C:\\fakepath\\', '')
      } else {
        formData.append('arquivo_carga_extra', this.formFechamentoExtra.arquivo_carga_extra.valor)
      }

      let elemComodato = this.$refs[this.formFechamentoExtra.arquivo_comodato.nome]

      if (elemComodato.value) {
        formData.append('arquivo_comodato', elemComodato.files[0])
        this.formFechamentoExtra.arquivo_comodato.valor = this.$refs.arquivo_comodato.value.replace('C:\\fakepath\\', '')
      } else {
        formData.append('arquivo_comodato', this.formFechamentoExtra.arquivo_comodato.valor)
      }

      let elemCargaComodato = this.$refs[this.formFechamentoExtra.arquivo_carga_comodato.nome]

      if (elemCargaComodato.value) {
        formData.append('arquivo_carga_comodato', elemCargaComodato.files[0])
        this.formFechamentoExtra.arquivo_carga_comodato.valor = this.$refs.arquivo_carga_comodato.value.replace('C:\\fakepath\\', '')
      } else {
        formData.append('arquivo_carga_comodato', this.formFechamentoExtra.arquivo_carga_comodato.valor)
      }

      // formData.append('arquivo', this.formFechamentoExtra.arquivo.valor)
      // formData.append('arquivo_extra', this.formFechamentoExtra.arquivo_extra.valor)
      formData.append('uf_id', this.$store.state.fechamentoExtra.dadosFechamento.uf_id)
      formData.append('ano_selecionado', this.$store.state.fechamentoExtra.dadosFechamento.ano_selecionado)
      formData.append('contrato_id', this.contrato.contrato_id)
      formData.append('mes_id', this.$store.state.fechamentoExtra.dadosFechamento.mes_id)
      formData.append('usuario_nome', this.$store.state.login.loginUsuario.usuario.name)
      formData.append('usuario_email', this.$store.state.login.loginUsuario.usuario.email)
      formData.append('servicos_ids', JSON.stringify(this.servicosSelecionados.map(s => s.id)))

      // formData.append('siglas', JSON.stringify(this.selected))
      return formData
    },
    preencherFormDataVerifiarRegistroAnterior () {
      let formData = new FormData()
      formData.append('ano_selecionado', this.$store.state.fechamentoExtra.dadosFechamento.ano_selecionado)
      formData.append('contrato_id', this.contrato.contrato_id)
      formData.append('mes_id', this.$store.state.fechamentoExtra.dadosFechamento.mes_id)
      return formData
    },
    limparDadosFormulario () {
      this.formFechamentoExtra.valor_extra.valor = ''
      this.formFechamentoExtra.valor_comodato.valor = ''
      this.formFechamentoExtra.descricao.valor = ''
      this.formFechamentoExtra.arquivo_comodato.valor = ''
      this.formFechamentoExtra.arquivo_carga_comodato.valor = ''
      this.formFechamentoExtra.arquivo_extra.valor = ''
      this.formFechamentoExtra.arquivo_carga_extra.valor = ''
      this.formFechamentoExtra.usuario_nome.valor = ''
      this.formFechamentoExtra.usuario_email.valor = ''
      this.servicoAtual = null
      this.servicosSelecionados = []
      this.$refs['arquivo_extra'].value = null
      this.$refs['arquivo_carga_extra'].value = null
      this.$refs['arquivo_comodato'].value = null
      this.$refs['arquivo_carga_comodato'].value = null
      // this.selected = ''
    },
    validacaoForm () {
      let validadoValorOi = false
      let validadoValorComodato = false
      let validadoDescricao = false

      // validando o comodato: se houver valor e arquivo de Oi, o valor de Comodato pode ser ignorado.
      if (this.formFechamentoExtra['valor_extra'].valor > 0 && this.formFechamentoExtra['arquivo_extra'].valor !== '' && this.formFechamentoExtra['valor_comodato'].valor >= 0) {
        validadoValorOi = true
      }
      // validando o comodato: se houver valor e arquivo de comodato, o valor de Oi pode ser ignorado.
      if (this.formFechamentoExtra['valor_comodato'].valor > 0 && this.formFechamentoExtra['arquivo_comodato'].valor !== '' && this.formFechamentoExtra['valor_extra'].valor >= 0) {
        validadoValorComodato = true
      }
      // validando a descrição
      if (this.formFechamentoExtra['descricao'].valor !== '') {
        validadoDescricao = true
      }
      console.log('validadoValorOi', validadoValorOi)
      console.log('validadoValorComodato', validadoValorComodato)
      console.log('validadoDescricao', validadoDescricao)
      console.log('final', validadoDescricao && (validadoValorComodato || validadoValorOi))
      return validadoDescricao && (validadoValorComodato || validadoValorOi)
    },
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.adicionarGlosa {
  transition: 1s;
  overflow: auto;
}

.alert-title {
  text-align: center;
  font-size: 1.3em;
}

.content-body {
  font-size: 1.3rem;
  padding: 1.2em;
}

.sucesso {
  color: #155724;
  background-color: #d4edda;
  border-color: #c3e6cb;
}

.falhou {
  color: #FFF;
  background-color: #2196F3;
}

.alert-title span {
  transform: rotate(90deg);
  display: inline-block;
  font-size: 1.1em;
  margin-left: .5em;
  font-weight: 600;
}

.modal {
  overflow: auto;
}

.modal-dialog {
  width: 800px;
}

.modal-header {
  background-color: #3b8dbc;
}

textarea {
  margin: auto;
  width: 100%;
  min-height: 6em;
  padding: 6px 8px;
  -webkit-transition: 1s;
  transition: 1s;
  outline-style: none;
  display: -webkit-inline-box;
  display: inline-flex;
  min-width: 320px;
  height: calc(1.5em + .75rem + 2px);
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 5px;
}

.input-group {
  width: 100%;
}

.formulario {
  width: 100%;
  padding: 1em;
  margin-left: 2%
}

select {
  background-color: #f9f9f9;
  padding: 5px;
  width: 100%;
}

.servico-selector {
  display: flex;
  gap: 8px;
  align-items: center;
}

.servico-selector select {
  flex: 1;
}

.btn-adicionar-servico {
  background-color: #3c8dbc;
  border-color: #367fa9;
  color: #fff;
  padding: 6px 14px;
  border: none;
  border-radius: 3px;
  cursor: pointer;
  transition: .5s;
  white-space: nowrap;
  margin-top: 0;
}

.btn-adicionar-servico:disabled {
  background-color: #aaa;
  cursor: not-allowed;
}

.btn-adicionar-servico:not(:disabled):hover {
  background-color: #00a65a;
}

.lista-servicos {
  list-style: none;
  padding: 0;
  margin: 10px 0 0 0;
}

.lista-servicos li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #eaf4fb;
  border: 1px solid #b8daee;
  border-radius: 4px;
  padding: 6px 10px;
  margin-bottom: 5px;
  font-size: 0.95em;
}

.btn-remover-servico {
  background: none;
  border: none;
  color: #c0392b;
  font-size: 1em;
  cursor: pointer;
  padding: 0 4px;
  margin-top: 0;
  line-height: 1;
  transition: color .3s;
}

.btn-remover-servico:hover {
  color: #922b21;
  background: none;
}

button {
  background-color: #3c8dbc;
  border-color: #367fa9;
  color: #fff;
  padding: 10px;
  border: none;
  margin-top: 10px;
  border-radius: 3px;
  cursor: pointer;
  transition: .5s;
}

button:hover {
  background-color: #00a65a;
}

input[type='file'] {
  padding: 0;
  margin: 0;
  padding-top: .5em;
  height: 3em;
  padding-right: 1em;
}

fieldset {
  min-width: inherit;
  width: 100%;
  padding: 10px;
  margin: initial;
  border: 1px solid #ccc;
}

legend {
  padding: .5em;
  display: inherit;
  width: auto;
  max-width: inherit;
  margin-bottom: inherit;
  font-size: inherit;
  line-height: inherit;
  color: inherit;
  white-space: inherit;
  border: none !important;
  margin-bottom: -5px;
  margin-top: -5px;
}
</style>



// WEBPACK FOOTER //
// AplicarExtraContratual.vue?1c97175f